import { defineSlotRecipe } from "@chakra-ui/react";
import { dialogAnatomy } from "@chakra-ui/react/anatomy";

// Restores the Chakra v2 modal metrics and sizes.
const dialogRecipe = defineSlotRecipe({
  slots: dialogAnatomy.keys(),
  base: {
    backdrop: {
      bg: "blackAlpha.600",
    },
    // `fontSize` + unitless `lineHeight` rather than `textStyle: "md"`: the text style's
    // fixed 24px line height would be inherited by the 12px copy inside the modals.
    content: {
      fontSize: "md",
      lineHeight: "1.5",
      borderRadius: "md",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    },
    header: {
      display: "block",
      py: "4",
      fontSize: "xl",
      fontWeight: "semibold",
    },
    body: {
      py: "2",
    },
    footer: {
      gap: "0",
      py: "4",
    },
    closeTrigger: {
      insetEnd: "3",
    },
  },
  variants: {
    size: {
      xs: { content: { maxW: "xs" } },
      sm: { content: { maxW: "sm" } },
      md: { content: { maxW: "md" } },
      lg: { content: { maxW: "lg" } },
      xl: { content: { maxW: "xl" } },
      popup: {
        content: { maxWidth: "400px" },
      },
      uploadPopup: {
        content: { maxWidth: "584px" },
      },
    },
  },
});

export default dialogRecipe;
